interface RestaurantResponse {
  data: Array<{
    restaurantId: string;
    phone: string | null;
    cuisineType: string | null;
    name: string;
    image: string | null;
    logo: string[];
    state: string | null;
    country: string | null;
    zipcode: string | null;
    address: string;
    alternativePhone: string | null;
    owner: string | null;
  }>;
}

export const restaurantService = {
  async getRestaurants(apiBaseUrl: string, accountId: string): Promise<RestaurantResponse> {
    if (!accountId) {
      throw new Error('No account ID available');
    }

    const response = await fetch(`${apiBaseUrl}/restaurant`, {
      method: 'GET',
      headers: {
        'API-Key': accountId,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch restaurants');
    }

    return response.json();
  },
};
